import {
  ArrayParam,
  ObjectParam,
  StringParam,
  NumericArrayParam,
  NumberParam,
  BooleanParam,
  JsonParam
} from 'use-query-params'

import { dateFormat } from '@app/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'
import { FILTERS_PARAMS_KEYS, MONITORING_TASK_STATUS, MONITORING_TASK_STATUS_TITLE } from '@app/api/constants'

import type { LntSelectOption } from '@app/components/base/Select/types'
import type { MonitoringRegistryDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<MonitoringRegistryDataSource> = {
  monitoringId: 'ID мониторинга',
  date: 'Дата',
  monitoringType: 'Тип мониторинга',
  promotionName: 'Рекламное мероприятие',
  promoDateFrom: 'Дата начала РМ Лента',
  promoDateTo: 'Дата оконч. РМ Лента',
  cluster: 'Кластер',
  monitoringSubtype: 'Подтип',
  contractor: 'Подрядчик',
  salesOrganization: 'Сбытовая организация',
  status: 'Статус'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.promoIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.contractorIds]: NumericArrayParam,
  [FILTERS_PARAMS_KEYS.status]: ArrayParam,
  [FILTERS_PARAMS_KEYS.week]: StringParam,
  [FILTERS_PARAMS_KEYS.createdAtAfter]: StringParam,
  [FILTERS_PARAMS_KEYS.createdAtBefore]: StringParam,
  [FILTERS_PARAMS_KEYS.showStopped]: BooleanParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<MonitoringRegistryDataSource> = {
  'table-monitoringId': NumberParam,
  'table-date': ObjectParam,
  'table-monitoringType': StringParam,
  'table-promotionName': StringParam,
  'table-promoDateFrom': ObjectParam,
  'table-promoDateTo': ObjectParam,
  'table-cluster': StringParam,
  'table-monitoringSubtype': StringParam,
  'table-contractor': StringParam,
  'table-salesOrganization': StringParam,
  'table-status': JsonParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

const options = Object.values(MONITORING_TASK_STATUS).map<LntSelectOption>(monitoringTaskStatus => {
  return {
    label: MONITORING_TASK_STATUS_TITLE[monitoringTaskStatus],
    value: monitoringTaskStatus
  }
})

export const columnsSearchSchema: ColumnTableSearchSchema<MonitoringRegistryDataSource> = {
  monitoringId: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
  date: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promotionName: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  promoDateFrom: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  promoDateTo: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringSubtype: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  contractor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  status: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options } }
}
